module.exports = __webpack_public_path__ + "img/xyzal_allergy_24_hr_tablets.e6c26914.jpg";